@if (consentService.shouldShowBanner()) {
  <aside class="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie preferences">
    <div class="banner-copy">
      <span class="banner-label">Cookie preferences</span>
      <p>
        We use essential cookies for site functionality and optional analytics cookies for performance insights.
        See our <a routerLink="/privacy" rel="noopener">Privacy Policy</a> and
        <a routerLink="/cookies" rel="noopener">Cookie Policy</a>.
      </p>
    </div>
    <div class="actions">
      <button type="button" class="btn-secondary" (click)="reject()">Reject optional cookies</button>
      <button type="button" class="btn-primary" (click)="accept()">Accept analytics cookies</button>
    </div>
  </aside>
}
